import React, { Component } from 'react';
import './App.css';
import { Appbar, Button, Container } from 'muicss/react';
import Input from 'muicss/lib/react/input';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Link
} from 'react-router-dom'
import {RaisedButton} from 'material-ui';
import firebase from 'firebase';
import Cookies from 'universal-cookie';

export class C93 extends Component {
  constructor(props) {
    super(props)
    console.log(props)
    this.state = this.configureStateFor(props)
  }

  download(path) {
    var storage = firebase.storage();
    var gsReference = storage.refFromURL(path)

    gsReference.getDownloadURL().then((url) => {
      console.log(`${url}`)
      this.setState({
        url: url
      })
    }).catch(function(error) {
      alert(error)
    });
  }

  configureStateFor(props) {
    return {
      isAuthorized: false,
      isLoggedIn: false
    }
  }

  componentDidMount () {
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          console.log("onAuthStateChanged -> login")
          this.setState({
            isAuthorized: true,
            isLoggedIn: true,
            url: ""
          })
        } else {
          console.log("onAuthStateChanged -> not login")
          this.setState({
            isAuthorized: true,
            isLoggedIn: false,
            url: ""
          })
        }
    })
  }

  render() {
    const cookies = new Cookies()
    // 認証通過によるsetStateが発生してない場合は待つ
    if (!this.state.isAuthorized) {
      return (
        <p>Loading...</p>
      )
    }
    // ログイン済
    if (this.state.isLoggedIn) {
      // TODO: シリアルキーの検証
      // Google Cloud Functionで、serialを投げるとgetDownloadURLを返すAPIを作る
      console.log("<TOP(LOGIN)>")
      const user = firebase.auth().currentUser
      console.log(`${user.email} ${user.uid}`)
      const email = user.email ? `(${user.email})` : ""
      return (
        <div className="App">
          <image src={user.photoURL} />
          <p>ユーザ: {user.displayName} {email}</p>
          <p>シリアルキー: {cookies.get("serialNo")}</p>
          <RaisedButton primary onClick={() => {
            this.download("gs://motelab/A5.pdf")
          }}>
          (C93)Good evening, A5[pdf版]を ダウンロード
          </RaisedButton>
          <hr/>
          <RaisedButton negative onClick={() => {
            firebase.auth().signOut().then(() => {
              console.log("SignOut")
            }, (error) => {
              console.error(error)
            });
          }}>
          ログアウト
          </RaisedButton>
        </div>
      )
    } else {
      // 未ログイン
      // TODO: Twitter, Facebookを追加
      console.log("<TOP(NOT LOGIN)>")
      var header = () => {
        if (cookies.get("serialNo")) {
          return <p>シリアルキー: {cookies.get("serialNo")}</p>
        } else {
          return <Input label="シリアルキー" type="text"/>
        }
      }
      return (
        <Container>
          <h2>[C93]「Good evening, A5」ダウンロードサイト</h2>
          {header()}
          <Button color="danger" onClick={() => {
            var provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithRedirect(provider).then((result) => {
              var token = result.credential.accessToken
              var user = result.user
              console.log(`${user} ${this.state}`)
            }).catch((error) => {
              console.error(error)
              var errorCode = error.code
              var errorMessage = error.message
              var email = error.email
              var credential = error.credential
            })
          }}>
            GoodleIDでログイン
          </Button>
          <Button color="primary" onClick={() => {
            var provider = new firebase.auth.TwitterAuthProvider();
            provider.setCustomParameters({
              'lang': 'jp'
            });
            firebase.auth().signInWithRedirect(provider).then((result) => {
              var token = result.credential.accessToken
              var secret = result.credential.secret
              var user = result.user
              console.log(`${user} ${this.state}`)
            }).catch((error) => {
              console.error(error)
              var errorCode = error.code
              var errorMessage = error.message
              var email = error.email
              var credential = error.credential
            })
          }}>
            Twitterでログイン
          </Button>
        </Container>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/c93.js